import { gql } from "@apollo/client";

// Define the GraphQL query for fetching media index tags
export const GET_MEDIAINDEX_TAGS_QUERY = gql`
  query GetMediaIndexTags($input: MediaIndexTagsInput!) {
    getMediaIndexTags(input: $input) {
      tags
    }
  }
`;
